import React from 'react';
import { ReactComponent as Warning } from '../../../../../assets/popups/warning.svg';
import usePopup from '../../../../helper/usePopup';
import { contentMap } from '../../ENUMS/INFO_POPUP_ENUM';

const NewInfoPopup = ({ info, type }) => {
  const { closeOrderPopup } = usePopup();
  return (
    <div className="wrong-popup">
      <Warning />
      <h3 dangerouslySetInnerHTML={{ __html: contentMap[type][info].text_big }} />
      <p>
        Pomoc: <a href="mailto:e-commerce@app4ad.pl">e-commerce@app4ad.pl</a>
      </p>
      <div className="single-button">
        <button className="button accept" onClick={() => closeOrderPopup()}>
          OK
        </button>
      </div>
    </div>
  );
};

export default NewInfoPopup;
